import { useEffect } from "react";
import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography, Skeleton } from '@albo-ui/core';
import { FormControl, FormControlLabel, TextField, Checkbox, Box } from '@mui/material';
import { useFilterCards } from './hooks/useFilterCards';
import { statusAfbCards } from '../../../util/DataObject';

export type FilterCardsDialogProps = {
    onConfirm: (data) => void;
    onClose: () => void;
    data: any;
    open: boolean;
    title: string;
} & DefaultComponentProps;

export const FilterCards = ({ open, title, data, onConfirm, onClose }: FilterCardsDialogProps) => {
    const { onHandleChange, form, error, isValid, loader } = useFilterCards(open, data)

    useEffect(() => {}, [loader])

    return (
        <Dialog onClose={onClose} open={open}>
            <DialogTitle>
                <Typography variant='h2'>{title}</Typography>
            </DialogTitle>
            {loader ? 
                <Skeleton width='100%' height='100px' style={{marginTop: 20}} />
                :  
                <DialogContent>
                    <FlexGrid container spacing={2} fullWidth style={{marginBlock: 15}}>
                        <FlexGrid item fullWidth>
                            <FormControl color='secondary' fullWidth>
                            <TextField
                                value={form["filters"]["dates"]["start"].slice(0,10)}
                                onChange={onHandleChange.bind(this, 'dates', 'start', null)}
                                label="Fecha inicio"
                                size="small"
                                type={"date"}
                                error={error !== ""}
                                helperText={error ? error : ""}
                                InputLabelProps={{ shrink: true }}
                            />
                            </FormControl>
                        </FlexGrid>

                        <FlexGrid item fullWidth>
                            <FormControl color='secondary' fullWidth >
                            <TextField
                                value={form["filters"]["dates"]["end"].slice(0,10)}
                                onChange={onHandleChange.bind(this, 'dates', 'end', null)}
                                label="Fecha fin"
                                size="small"
                                type={"date"}
                                error={error !== ""}
                                helperText={error ? error : ""}
                                InputLabelProps={{ shrink: true }}
                            />
                            </FormControl>
                        </FlexGrid>
                    </FlexGrid>
                    <FlexGrid container style={{ maxHeight: `${((Math.ceil(statusAfbCards.length/2))* 3.7)+8}rem`}} >
                        <Box sx={{flexFlow: "column wrap",  display: "-webkit-box"}}>
                            {statusAfbCards?.map((item, index) => (
                                <FormControlLabel key={index} control={<Checkbox checked={form["filters"]["status"].includes(item["key"])} onChange={onHandleChange.bind(this, "status", null, item["key"])}/>} label={item["label"]} style={{width: "48%"}} />
                            ))}
                        </Box>
                    </FlexGrid>
                </DialogContent>
            }
            <DialogActions>
                <FlexGrid fullHeight fullWidth container spacing={2} justify='space-between' style={{ marginTop: '20px'}}>
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType='secondary' size='normal'>
                            Cancelar
                        </Button>
                    </FlexGrid>
                    <FlexGrid item>
                        <Button disabled={isValid} onClick={() => onConfirm(form)} size='normal'>
                            Aceptar
                        </Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    )
}